import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/inferences/detail';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process({ payload }) {
  try {
    const { uid } = payload || {};
    const response = yield call(
      axios.get,
      `${config.API_URL}/inference/${uid}`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
